import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useWidgetSelector, useWidgetDispatch } from "../../../store/store";
import AnimateHeight from "react-animate-height";
import { X, AlertCircle } from "react-feather";
import { State } from "../../../store/state";
import { clearApiError } from "../../../store/actions";
import styles from "./ApiErrorNotification.module.scss";
export const ApiErrorNotification: React.FC<{
  genericErrorMessage?: string;
}> = t0 => {
  const $ = _c(19);
  const {
    genericErrorMessage: t1
  } = t0;
  const genericErrorMessage = t1 === undefined ? "Something went wrong, please try again later." : t1;
  const dispatch = useWidgetDispatch();
  const apiError = useWidgetSelector(_temp);
  const [isVisible, setIsVisible] = useState(typeof apiError !== "undefined");
  const [message, setMessage] = useState(apiError ?? null);
  const [prevApiError, setPrevApiError] = useState(apiError);
  if (apiError !== prevApiError) {
    setPrevApiError(apiError);
    if (typeof apiError !== "undefined") {
      setMessage(apiError);
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }
  let t2;
  if ($[0] !== dispatch) {
    t2 = () => {
      setIsVisible(false);
      setTimeout(() => {
        dispatch(clearApiError());
      }, 250);
    };
    $[0] = dispatch;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] !== handleClose || $[3] !== isVisible) {
    t3 = () => {
      if (isVisible) {
        const timer = setTimeout(() => {
          handleClose();
        }, 8000);
        return () => clearTimeout(timer);
      }
    };
    $[2] = handleClose;
    $[3] = isVisible;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isVisible) {
    t4 = [isVisible];
    $[5] = isVisible;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t3, t4);
  const t5 = isVisible ? "auto" : 0;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.icon}><AlertCircle size={24} /></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = message || genericErrorMessage;
  let t8;
  if ($[8] !== t7) {
    t8 = <div className={styles.message}>{t7}</div>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <X size={24} />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== handleClose) {
    t10 = <button className={styles.closeButton} onClick={handleClose} aria-label="Close notification">{t9}</button>;
    $[11] = handleClose;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8) {
    t11 = <div className={styles.wrapper} data-cy="api-error-notification"><div className={styles.content}>{t6}{t8}{t10}</div></div>;
    $[13] = t10;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t5) {
    t12 = <AnimateHeight height={t5} duration={300} animateOpacity={true}>{t11}</AnimateHeight>;
    $[16] = t11;
    $[17] = t5;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
function _temp(state) {
  return state.donation.apiError;
}